// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608181527/js/" + chunkId + "." + {"44":"f6708e5d","225":"807cecbb","481":"fef6ddcc","486":"c7f42335","770":"ad5a0631"}[chunkId] + ".0.22548059370824103.chunk.js";
};